import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OwnStrategiesRoutingModule } from './own-strategies-routing.module';
import { StaticPageFooterModule } from 'src/app/shared/static-page-footer/static-page-footer.module';
import { OwnStrategiesComponent } from 'src/app/pages/own-strategies/own-strategies.component';
import { HtmlFormatPipeModule } from 'src/app/pipes/html-format-pipe.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    OwnStrategiesComponent,
  ],
  imports: [
    CommonModule,
    OwnStrategiesRoutingModule,
    StaticPageFooterModule,
    HtmlFormatPipeModule,
    TranslateModule,
    RouterModule,
  ], exports: [
    OwnStrategiesComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class OwnStrategiesModule { }
